<template>
  <div>
    <div class="topbox">
      <div class="leftBox">
        <img
          src="../../assets/logo.png"
          alt=""
        />
      </div>
      <div
        class="rightBox"
        @click.stop="show=true"
      >
        <img
          src="../../assets/set.png"
          alt=""
        />
      </div>
    </div>
    <van-popup
      class="navBox"
      v-model="show"
      position="right"
      :overlay="true"
      duration="0.4"
      closeable
      @click.stop="show=false"
    >
      <div class="nav">
        <template v-for="item in menuList">
          <div
            v-if="item.childList && item.childList.length"
            :key="item.key"
            :class="`nav_li ${item.key == id ? 'active' : ''}`"
            @click.stop="item.open=!item.open"
          >
            <div
              :class="`d-flex justify-space-between ${item.open?'border-bo':''}`"
            >
              <div>
                {{item.title}}
              </div>
              <div class="menu-icon">
                <van-icon v-if="!item.open" name="arrow-down" size="24" />
                <van-icon v-if="item.open" name="arrow-up" size="24" />
              </div>
            </div>
            <div
              v-if="item.childList.length > 0"
              v-show="item.open"
              v-for="childItem in item.childList"
              :key="childItem.key"
            >
              <div
                :class="`nav_child_li ${childItem.key == id ? 'active' : ''}`"
                @click.stop="changerouter(childItem)"
              >
                {{childItem.title}}
              </div>
            </div>
          </div>
          <div
            v-else
            :key="item.key"
            @click.stop="changerouter(item)"
            :class="`nav_li ${item.key == id ? 'active' : ''}`"
          >
            {{item.title}}
          </div>
        </template>

      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      id: 1,
      activeNames: 1,
      menuList: [
        {
          key: "1",
          title: "首页",
          path: "/index",
        },
        {
          key: "2",
          title: "关于旷真",
          open: false,
          childList: [
            {
              key: "2-1",
              title: "旷真简介",
              path: "/about",
            },
            {
              key: "2-2",
              title: "常见问答",
              path: "/about",
              query: { tab: "常见问答" },
            },
          ],
        },
        {
          key: 3,
          title: "业务领域",
          open: false,
          childList: [
            {
              key: "3-1",
              title: "应收款",
              path: "/receivables",
            },
            {
              key: "3-2",
              title: "婚姻家事",
              path: "/marriage",
            },
            {
              key: "3-3",
              title: "刑事辩护",
              path: "/criminal",
            },
            {
              key: "3-4",
              title: "债务重组",
              path: "/debtRestructuring",
            },
            {
              key: "3-5",
              title: "物业法律顾问",
              path: "/propertyLegalServices",
            },
          ],
        },
        {
          key: 7,
          title: "旷真案例",
          path: "/cases",
        },
        {
          key: 4,
          title: "新闻动态",
          path: "/newsInformation",
        },
        {
          key: 5,
          title: "加入旷真",
          path: "/joinUs",
        },
        {
          key: 6,
          title: "联系我们",
          path: "/contactUs",
        },
      ],
    };
  },
  methods: {
    changerouter(item) {
      this.id = item.key;
      const query = item.query || {};
      const samePath = item.path === this.$route.path;
      const currentQuery = this.$route.query || {};
      const sameQuery =
        Object.keys(query).every((key) => String(currentQuery[key] || "") === String(query[key] || "")) &&
        Object.keys(currentQuery).every((key) => String(currentQuery[key] || "") === String(query[key] || ""));
      if (samePath && sameQuery) {
        window.location.reload();
      } else {
        this.$router.push({ path: item.path, query }).catch(() => {});
      }
      this.show = !this.show;
    },
  },
  watch: {
    show(value) {
      if (!value) {
        this.menuList.forEach(item => {
          item.open = false;
        })
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.topbox {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  padding: 0.4rem 0.5rem;
  box-sizing: border-box;
  overflow: hidden;
  height: 50px;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.3);
  .leftBox {
    float: left;
    width: 2rem;
    img {
      width: 80%;
    }
  }
  .rightBox {
    float: right;
    width: 0.4rem;
    height: 0.4rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.navBox {
  width: 72vw;
  height: 100vh;
  background: #222222;
  .nav {
    padding: 0.8rem 0.6rem;
    .nav_li {
      font-family: PingFangSC-Regular, PingFang SC;
      font-size: 0.36rem;
      color: #fff;
      display: block;
      line-height: 1.2rem;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
      text-transform: uppercase;
      .nav_child_li {
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 0.36rem;
        color: #fff;
        display: block;
        line-height: 1.2rem;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        text-transform: uppercase;
        padding-left: 0.5rem;
      }
      .nav_child_li.active {
        color: #ab0000;
        font-weight: 700;
      }
    }
    .nav_li.active {
      color: #ab0000;
      font-weight: 700;
    }
  }
  .d-flex {
    display: flex;
  }
  .justify-space-between {
    justify-content: space-between;
  }
  .border-bo {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }
  .menu-icon {
    
  }
}
</style>
